import React, { useEffect, useState } from "react";
import BaseModal from "components/BaseModal";
import { fetchWrapper } from "utils/apiFetch";

export default function SelectPaysprintBank({ show, onClose, onSelect }) {
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) fetchBanks();
  }, [show]);

  const fetchBanks = async () => {
    setLoading(true);
    try {
      const res = await fetchWrapper("https://api.mokshiq.in/paysprint_dmt_bank_list");
      const json = res;
      setList(json?.data || []);
    } finally {
      setLoading(false);
    }
  };

  const filtered = list.filter((b) =>
    b.bank_name.toLowerCase().startsWith(search.toLowerCase())
  );

  return (
    <BaseModal show={show} onClose={onClose} title="Select Bank Name">
      <div className="mb-2">
        <input
          className="form-control"
          placeholder="Search bank"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div style={{ maxHeight: 350, overflowY: "auto" }}>
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : (
          filtered.map((bank) => (
            <div
              key={bank.bank_id}
              className="p-2 border-bottom cursor-pointer"
              onClick={() => {
                onSelect(bank);
                onClose();
              }}
              style={{ cursor: "pointer", fontWeight: 600 }}
            >
              {bank.bank_name}
            </div>
          ))
        )}
      </div>
    </BaseModal>
  );
}
